<script>
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";

export default {
    props: {
        vacation: Boolean,
        records: Array,
        loading: Boolean,
    },
    setup(props, {emit}) {
        const {$i18n} = useTools();
        const {translateMonth, formatedDate, priceFormat} = useSharedMethod();
        
        const headers = [
            props.vacation ? {
                text: $i18n.t('common.month'),
                align: "start",
                sortable: true,
                value: "month",
                width: "0%"
            } : {
                text: $i18n.t('common.date'),
                align: "start",
                sortable: true,
                value: "date",
                width: "0%"
            },
            {
                text: $i18n.t('common.action'),
                align: "start",
                sortable: true,
                value: "direction",
                width: "0%"
            },
            {
                text: $i18n.t('common.type'),
                align: "start",
                sortable: true,
                value: "type",
            },
            {
                text: $i18n.t('common.value'),
                align: "start",
                sortable: true,
                value: "value",
            },
        ];
        
        if (props.vacation) {
            headers.push(
                {
                    text: $i18n.t('balance.plate_base'),
                    align: "start",
                    sortable: true,
                    value: "plateBase"
                },
            )
        }
        
        headers.push(
            {
                text: $i18n.t('common.comment'),
                align: "start",
                sortable: true,
                value: "observation"
            },
            {
                text: "",
                align: "start",
                sortable: false,
                value: "consult"
            }
        );
        
        function consult(item) {
            emit('consult', item);
        }
        
        return {
            headers,
            translateMonth,
            formatedDate,
            priceFormat,
            consult
        }
    }
}
</script>

<template>
    <w-data-table
        :headers="headers"
        :items="records"
        :loading="loading"
        sort-by="dateTime"
        sort-desc
        disable-pagination
        fixed-header
        height="396"
    >
        <template v-slot:[`item.date`]="{ item }">
            <w-inline-text bold :text="formatedDate(item.date)"/>
        </template>
        <template v-slot:[`item.month`]="{ item }">
            <w-inline-text bold :text="translateMonth(item.month, true)"/>
        </template>
        <template v-slot:[`item.type`]="{ item }">
            <w-inline-text :text="$t(`balance.type_${item.type}`)"/>
        </template>
        <template v-slot:[`item.direction`]="{ item }">
            <v-icon v-if="item.direction === 'IN'" color="teal">mdi-plus-circle-outline</v-icon>
            <v-icon v-if="item.direction === 'OUT'" color="red">mdi-minus-circle-outline</v-icon>
        </template>
        
        <template v-slot:[`item.value`]="{ item }">
            <w-chip outlined :text="item.value"/>
        </template>
        <template v-slot:[`item.plateBase`]="{ item }">
            <w-inline-text :text="priceFormat(item.plateBase)"/>
        </template>
        <template v-slot:[`item.plate`]="{ item }">
            <w-inline-text :text="priceFormat(item.plate)"/>
        </template>
        <template v-slot:[`item.consult`]="{ item }">
            <v-btn
                v-if="['ABSENCE_REQUEST', 'MANUAL_GATHERING', 'GATHERING', 'PAY_SLIP'].includes(item.type)"
                icon
                color="blue"
                @click="consult(item)"
            >
                <v-icon>mdi-hammer-screwdriver</v-icon>
            </v-btn>
        </template>
    </w-data-table>
</template>